export const AID_PROGRAM_ESA_PLUS = 'ESA+';
export const AID_PROGRAM_OPPORTUNITY_SCHOLARSHIP = 'Opportunity Scholarship';

const LABELS: Record<string, string> = {
  '1': AID_PROGRAM_ESA_PLUS,
  esa: AID_PROGRAM_ESA_PLUS,
  'esa+': AID_PROGRAM_ESA_PLUS,
  '2': AID_PROGRAM_OPPORTUNITY_SCHOLARSHIP,
  os: AID_PROGRAM_OPPORTUNITY_SCHOLARSHIP,
  'opportunity scholarship': AID_PROGRAM_OPPORTUNITY_SCHOLARSHIP
};

const IDS: Record<string, number> = {
  [AID_PROGRAM_ESA_PLUS]: 1,
  [AID_PROGRAM_OPPORTUNITY_SCHOLARSHIP]: 2
};

type AidProgramValue = string | number | null | undefined;

export function toAidProgramLabel(value: AidProgramValue): string | undefined {
  return LABELS[String(value ?? '').trim().toLowerCase()];
}

export function toAidProgramTypeId(value: AidProgramValue): number | undefined {
  const label = toAidProgramLabel(value);
  return label ? IDS[label] : undefined;
}

export function toAidProgramTypeIds(values: AidProgramValue[] | null | undefined): number[] {
  return [...new Set((values ?? []).map(toAidProgramTypeId).filter((id): id is number => id != null))];
}

export function parseAidProgramEligibility(
  programType?: string | string[] | null,
  programTypeId?: number | string | null,
  programTypeIds?: Array<number | string> | null
): string[] {
  const parts = Array.isArray(programType) ? programType : programType?.split(',') ?? [];

  return (
    [programTypeIds, parts, [programTypeId]]
      .map(uniqueLabels)
      .find((labels) => labels.length) ?? []
  );
}

function uniqueLabels(values: AidProgramValue[] | null | undefined): string[] {
  return [...new Set((values ?? []).map(toAidProgramLabel).filter((label): label is string => Boolean(label)))];
}
